// extracted by mini-css-extract-plugin
module.exports = {"name":"columns_name__135bs","popverContent":"columns_popverContent__1rZ7C","remarkStyle":"columns_remarkStyle__1fRXw"};